<template>
  <!-- 可拖动进度条 -->
  <div class="c-progress">
    <div class="c-progress-outer" :style="setProgressBgStyle" ref="progress">
      <div class="c-progress-inner" :style="setProgressStyle"></div>
      <div v-if="showSlider" class="c-progress-slider" ref="slider" :style="setSliderStyle"></div>
    </div>
    <span class="percent-text" v-if="showText">{{ tempPercent }}%</span>
  </div>
</template>

<script>
// 使用了element的颜色
const colorTable = {
  success: '#13ce66',
  fail: '#ff4949',
  warning: '#e6a23c',
  default: '#409EFF',
}
export default {
  name: 'CProgress',
  props: {
    // 百分比
    percent: {
      type: Number,
      default: 0,
    },
    // 展示滑块
    showSlider: {
      type: Boolean,
      default: true,
    },
    // 展示文本
    showText: {
      type: Boolean,
      default: true,
    },
    // 进度条的宽度
    width: {
      type: Number,
      default: 370,
    },
    // 背景色
    bgColor: {
      type: String,
      default: '#ebeef5',
    },
    // 进度条颜色
    progressColor: {
      type: String,
      default: '#409EFF',
    },
    // 滑块的宽度
    sliderWidth: {
      type: Number,
      default: 20,
    },
    // 颜色的类型
    type: {
      type: String,
      default: colorTable.default,
    },
  },
  watch: {
    percent() {
      // 重新计算滚动条位置
      this.sliderLeft = (this.width / 100) * this.percent
      //console.log(this.sliderLeft,this.sliderWidth,this.percent,this.width)
      this.progressWidth = this.sliderLeft + this.sliderWidth
      this.tempPercent = this.percent
    },
  },
  data() {
    return {
      // 滑块相对父元素发x坐标
      sliderLeft: 0,
      // 进度条当前的的宽度
      progressWidth: 0,
      tempPercent: 0,
    }
  },
  computed: {
    // 设置进度条的背景样式
    setProgressBgStyle() {
      return {
        // 加上滑块的宽度
        width: `${this.width + this.sliderWidth}px`,
      }
    },
    // 设置进度条的样式
    setProgressStyle() {
      const color = colorTable[this.type] || this.progressColor
      return {
        width: `${this.progressWidth}px`,
        background: color,
      }
    },
    // 设置滑块的样式
    setSliderStyle() {
      const color = colorTable[this.type] || this.progressColor
      return {
        border: `1px solid ${color}`,
        width: `${this.sliderWidth}px`,
        height: `${this.sliderWidth}px`,
        left: `${this.sliderLeft}px`,
      }
    },
  },
  mounted() {
    this.sliderLeft = (this.width / 100) * this.percent
    // 滑块的x坐标加上滑块的宽度
    this.progressWidth = this.sliderLeft + this.sliderWidth
    this.tempPercent = this.percent
    this.addListener()
  },
  methods: {
    addListener() {
      const slider = this.$refs.slider
      const progress = this.$refs.progress
      console.log(slider, progress)
      let isClickSlider = false
      // 滑块与点击坐标的绝对距离
      let distance = 0
      progress.onclick = e => {
        // 阻止事件冒泡
        if (e.target === slider) {
          return
        }
        let curX = progress.offsetLeft
        this.sliderLeft = e.offsetX - curX
        if (this.sliderLeft <= 0) {
          this.sliderLeft = 0
        }
        if (this.sliderLeft >= this.width) {
          this.sliderLeft = this.width
        }
        this._countCurPercent()
      }
      if (slider) {
        slider.onmousedown = e => {
          isClickSlider = true
          let curX = slider.offsetLeft
          // 得出绝对距离
          distance = e.pageX - curX
        }
      }
      progress.onmousemove = e => {
        if (isClickSlider) {
          // 判断是否已经超出进度条的长度
          if (e.pageX - distance >= 0 && e.pageX - distance <= this.width - 0) {
            this.sliderLeft = e.pageX - distance
            this._countCurPercent()
          }
        }
      }
      progress.onmouseup = () => {
        isClickSlider = false
      }
    },
    // 算出百分比
    _countCurPercent() {
      this.tempPercent = Math.ceil(parseInt((this.sliderLeft / this.width) * 100))
      this.progressWidth = this.sliderLeft + this.sliderWidth
      // 取整的时候宽度可能不为0，所以在0和100的时候也将宽度取整
      if (this.tempPercent <= 0) {
        this.progressWidth = 0
        this.sliderLeft = 0
      }
      if (this.tempPercent >= 100) {
        this.progressWidth = this.width + this.sliderWidth
        this.sliderLeft = this.width
      }
      this.$emit('percentChange', this.tempPercent)
    },
  },
}
</script>

<style scoped>
.c-progress {
  display: flex;
  align-items: center;
}
.percent-text {
  margin-left: 5px;
  font-size: 14px;
  color: #666;
}
.c-progress-slider {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #409eff;
  position: absolute;
  z-index: 10;
  left: 10px;
}
.c-progress-outer {
  width: 300px;
  height: 25px;
  border-radius: 5px;
  background: #ebeef5;
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.c-progress-inner {
  width: 100px;
  height: 25px;
  background: #409eff;
  border-radius: 5px;
}
</style>
